const constCofig ={
     invitationCode: '',
     userDetails: ''
};

export default constCofig;